import { createGetChannel } from '../utils/apis/requestRX';
import { Fetch, ResponseData, ResponseList } from '../utils/apis/typeRX';

//获取图片验证码
export const getCaptcha: Fetch<{}, ResponseData<string>> = createGetChannel('/api/reexuan-blockchain-service/explorer/captcha/init');